// extracted by mini-css-extract-plugin
export default {"select":"select_select__r7MX5","selectError":"select_selectError__MGFwA","label":"select_label__AsRyF"};